import { css } from '@emotion/react'
import styled from '@emotion/styled'
import { AnswerCall } from '@liveHelper/assets/AnswerCall'
import { Z_INDEX } from '@liveHelper/constants'
import { ActionButton, FlexCenter } from '@oneToOne/shared/styles'

import { Button } from '@core/components/Button'

/* ***************** */
/* Shared CSS Blocks */
/* ***************** */
export const TruncateText = css`
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
`

/* ************************ */
/* Shared Styled Components */
/* ************************ */
export const AudioOnlyButton = styled(Button)`
  width: 100%;
  background: var(--one-to-one-green);
  border-radius: var(--spacing-48);
  height: var(--spacing-32);
  font-weight: var(--font-medium);
  gap: var(--spacing-8);
`

export const RingingPhoneIcon = styled(AnswerCall)`
  animation: phone-ring 1.2s ease-in-out infinite;

  @keyframes phone-ring {
    0% {
      transform: rotate(0deg);
    }

    10% {
      transform: rotate(-10deg);
    }

    20% {
      transform: rotate(10deg);
    }

    30% {
      transform: rotate(-10deg);
    }

    40% {
      transform: rotate(10deg);
    }

    50% {
      transform: rotate(-10deg);
    }

    60% {
      transform: rotate(10deg);
    }

    70% {
      transform: rotate(-10deg);
    }

    80% {
      transform: rotate(0deg);
    }

    100% {
      transform: rotate(0deg);
    }
  }
`

export const AgentImage = styled.img`
  width: 100%;
  height: 100%;
  object-fit: cover;
  object-position: top;
`

export const OnlineIndicator = styled.div<{ hasLastUnreadMessage: boolean }>`
  background-color: var(--green);
  border-radius: 50%;
  height: ${({ hasLastUnreadMessage }) =>
    hasLastUnreadMessage ? '18px' : '22px'};
  width: ${({ hasLastUnreadMessage }) =>
    hasLastUnreadMessage ? '18px' : '22px'};
  position: absolute;
  bottom: ${({ hasLastUnreadMessage }) =>
    hasLastUnreadMessage ? '-2px' : '-8px'};
  right: ${({ hasLastUnreadMessage }) =>
    hasLastUnreadMessage ? '-2px' : '-8px'};
  z-index: ${Z_INDEX.ONLINE_INDICATOR};
`

export const Row = styled.div`
  ${FlexCenter}
  gap: var(--spacing-8);
`

export const CTACloseButton = styled(ActionButton)`
  position: absolute;
  top: 6px;
  right: 6px;
`

export const FireworkLogoWrapper = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  padding: var(--spacing-4);
  border-top: 1px solid var(--gray-6);
  position: absolute;
  bottom: 0;
`

export const IdleExpandedContainer = styled.div<{
  isMobileWebEnabled: boolean
}>`
  display: flex;
  flex-direction: column;
  background-color: var(--white);
  width: 100%;
  height: 100%;
  border-radius: ${(props) =>
    props.isMobileWebEnabled ? 'none' : 'var(--border-radius-md)'};
  box-shadow: var(--box-shadow);
  overflow: hidden;
  padding-bottom: var(--spacing-18);
`
